// client/src/admin/dashboard/useMenuItems.js
import React from "react";
import { useContext } from "react";
import { TranslateContext } from "../../context/TranslateContext";
import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  SupportAgent as SupportIcon,
  Instagram as InstagramIcon,
  AccountTree as FlowIcon,
  HowToReg as ClaimsIcon,
} from "@mui/icons-material";

export const useMenuItems = () => {
  const { lang } = useContext(TranslateContext);

  return [
    {
      id: "dashboards",
      text: lang?.dashboards || "Dashboard",
      icon: <DashboardIcon />,
    },
    {
      id: "manage-users",
      text: lang?.users || "Users",
      icon: <GroupIcon />,
    },
    {
      id: "support-tickets",
      text: lang?.supportTickets || "Support Tickets",
      icon: <SupportIcon />,
    },
    {
      id: "instagram-settings",
      text: lang?.instagramSettings || "Instagram",
      icon: <InstagramIcon />,
    },
    {
      id: "flow-builder",
      text: lang?.flowBuilder || "Flow Builder",
      icon: <FlowIcon />,
    },
    {
      id: "follow-claims",
      text: lang?.followClaims || "Follow Claims",
      icon: <ClaimsIcon />,
    },
  ];
};
